import React, { memo } from 'react';
import { Check, Zap, Smile, BookOpen } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-amber-50" data-id="element-213">
      <div className="container mx-auto px-4" data-id="element-214">
        <div className="text-center mb-16" data-id="element-215">
          <span className="text-blue-900 font-bold tracking-wider uppercase text-sm" data-id="element-216">
            La Transformación
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 mb-6" data-id="element-217">
            Ahora imaginá esto
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-218">
            Entrás al aula con la clase resuelta. Sabés exactamente qué
            explicar, cómo bajarlo y qué actividad usar.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-20" data-id="element-219">
          <div className="bg-white p-8 rounded-2xl border border-amber-200 hover:shadow-lg transition-shadow" data-id="element-220">
            <div className="bg-blue-900 w-12 h-12 rounded-lg flex items-center justify-center mb-6" data-id="element-221">
              <Zap className="text-amber-400 h-6 w-6" data-id="element-222" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-223">
              Clases Dinámicas
            </h3>
            <p className="text-slate-600" data-id="element-224">
              Los alumnos entienden. Participan. Opinan. El Derecho se conecta
              con la vida real y dejan de memorizar para empezar a razonar.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-amber-200 hover:shadow-lg transition-shadow" data-id="element-225">
            <div className="bg-blue-900 w-12 h-12 rounded-lg flex items-center justify-center mb-6" data-id="element-226">
              <Smile className="text-amber-400 h-6 w-6" data-id="element-227" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-228">
              Tranquilidad Total
            </h3>
            <p className="text-slate-600" data-id="element-229">
              Sentís seguridad y control. No te llevás trabajo a casa. No
              improvisás. No vivís más el "mañana tengo Derecho y no sé qué
              dar".
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-amber-200 hover:shadow-lg transition-shadow" data-id="element-230">
            <div className="bg-blue-900 w-12 h-12 rounded-lg flex items-center justify-center mb-6" data-id="element-231">
              <BookOpen className="text-amber-400 h-6 w-6" data-id="element-232" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-233">
              Sistema Completo
            </h3>
            <p className="text-slate-600" data-id="element-234">
              Enseñar Derecho con clases claras, actuales y listas para usar,
              sin volver a preparar material desde cero nunca más.
            </p>
          </div>
        </div>

        <div className="bg-blue-900 rounded-3xl p-8 md:p-16 text-center max-w-5xl mx-auto relative overflow-hidden" data-id="element-235">
          <div className="relative z-10" data-id="element-236">
            <h3 className="text-2xl md:text-3xl font-bold text-amber-400 mb-6" data-id="element-237">
              La verdad que nadie dice
            </h3>
            <p className="text-lg text-amber-100 mb-8 max-w-2xl mx-auto" data-id="element-238">
              El problema no es la falta de material. Material hay de sobra.{' '}
              <br data-id="element-239" />
              <span className="text-amber-400 font-bold" data-id="element-240">
                El problema es no tener un sistema completo.
              </span>
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-left max-w-4xl mx-auto" data-id="element-241">
              {['Nivel secundario argentino', 'Aula real', 'Ciclo lectivo completo', 'Tiempo real del docente'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-blue-800/50 p-3 rounded-lg border border-blue-700" data-id="element-242">
                  <Check className="text-amber-400 h-5 w-5 flex-shrink-0" data-id="element-243" />
                  <span className="text-amber-50 text-sm font-medium" data-id="element-244">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}